export const CaseType: string[] = [
	'Cancer-Breast',
	'Cancer-Lung',
	'Cancer-Other',
	'Cancer-Skin',
	'Cardiac-MI',
	'Cardiac-Other',
	'Compartment Syn',
	'Cosmetic',
	'Dental Injury',
	'Ear/Nose/Throat',
	'Elopement',
	'Eye-Lasik',
	'Eye-Other',
	'Genitourinary',
	'Gynecological',
	'Hemorrhage',
	'HIPAA',
	'Infect-abdomen',
	'Infect-Hep/HIV',
	'Infect-nec fasc',
	'Infect-pneum',
	'Infection-Other',
	'Lap Cholecystec',
	'Legal Assist',
	'Med Error',
	'Mental/Psych',
	'N/A',
	'Neuro-other',
	'Neuro-stroke',
	'OB Baby-Other',
	'OB Baby-CP',
	'OB Baby-Sh Dyst',
	'OB Mother',
	'OB Mother/Baby',
	'Ortho-Other',
	'Ortho-arthropl',
	'Pain Mgmt',
	'Peer Rev/Defam',
	'Pneumothorax',
	'Positioning',
	'Property Loss',
	'Pulm Embolism',
	'Radiology',
	'Resuscitation',
	'Sexual Conduct',
	'Skin-Burn/Ulcer',
	'Slip/Fall-GL',
	'Slip/Fall-PL',
	'Surg-Bariatric',
	'Surg-Other',
	'Surg-Site/RFO',
	'Surg - Spine',
];

export const LossType: string[] = [
	'APDC',
	'BMP',
	'Claim',
	'Cyber-Claim',
	'Cyber-Suit',
	'HEAL - Incident',
	'Heal - PCE',
	'Incident',
	'Medefense',
	'Multi-CLM',
	'Multi-INC',
	'Multi-PCE',
	'Multi-Suit',
	'PCE',
	'PME',
	'Pre-Suit',
	'SIR-BMP',
	'SIR-Claim',
	'SIR-Incident',
	'SIR-PCE',
	'SIR-Suit',
	'Suit',
	'TPA-Claim',
	'TPA-Incident',
	'TPA-Suit',
	'Not Listed'
];

export const Allegations = [{
		key: 'Failure to Take Appropriate Action',
		values: [
			'Failure to Use Aseptic Technique',
			'Failure to Diagnose',
			'Failure to Delay a Case When Indicated',
			'Failure to Identify Fetal Distress',
			'Failure to Treat Fetal Distress',
			'Failure to Medicated',
			'Failure to Monitor',
			'Failure to Order Appropriate Medication',
			'Failure to Order Appropriate Test',
			'Failure to Perform Preoperative Evaluation',
			'Failure to Perform Procedure',
			'Failure to Perform Resuscitation',
			'Failure to Recognize a Complication',
			'Failure to Treat',
		],
	},
	{
		key: 'Delay in Performance',
		values: [
			'Delay in Diagnosis',
			'Delay in Performance',
			'Delay in Treatment',
			'Delay in Treatment of Identified Fetal Distress',
		],
	},
	{
		key: 'Error / Improper Performance',
		values: [
			'Administration of Blood or Fluids Problem',
			'Agent Use or Selection Error',
			'Complementary or Alternative Medication Problem',
			'Equipment Utilization Problem',
			'Improper Choice of Delivery Method',
			'Improper Management',
			'Improper Performance',
			'Improperly Performed C-Section',
			'Improperly Performed Vaginal Delivery',
			'Improperly Performed Resuscitation',
			'Improperly Performed Test',
			'Improper Technique',
			'Intubation Problem',
			'Laboratory Error',
			'Pathology Error',
			'Medication Administered via Wrong Route',
			'Patient History, Exam, or Workup Problem',
			'Problems With Patient Monitoring in Recovery',
			'Patient Monitoring Problem',
			'Patient Positioning Problem',
			'Problem with Appliance, Prostheses, Orthotic, Device, etc.',
			'Radiology or Imaging Error',
			'Surgical or Other Foreign Body Retained',
			'Wrong or Misdiagnosis (e.g. Original Diagnosis is Incorrect)',
			'Wrong Dosage Administered',
			'Wrong Dosage Dispensed',
			'Wrong Dosage Ordered of Correct Medication',
			'Wrong Medication Administered',
			'Wrong Medication Dispensed',
			'Wrong Medication Ordered',
			'Wrong Body Part',
			'Wrong Blood Type',
			'Wrong Equipment',
			'Wrong Patient',
			'Wrong Procedure or Treatment',
		],
	},
	{
		key: 'Unnecessary / Contraindicated Procedure',
		values: [
			'Contraindicated Procedure',
			'Surgical or Procedural Clearance Contraindicated',
			'Unnecessary Procedure',
			'Unnecessary Test',
			'Unnecessary Treatment',
		],
	},
	{
		key: 'Communication / Supervision',
		values: [
			'Communication Problem Between Practitioners',
			'Failure to Instruct or Communicate with Patient or Family',
			'Failure to Report on Patient Condition',
			'Failure to Respond to Patient Condition',
			'Failure to Supervise',
			'Improper Supervision',
		],
	},
	{
		key: 'Continuity of Care / Care Management',
		values: [
			'Failure/Delay in Admission to Hospital or Institution',
			'Failure/Delay in Referral or Consultation',
			'Premature Discharge from Institution',
			'Altered, Misplaced or Prematurely Destroyed Records',
		],
	},
	{
		key: 'Behavioral / Legal',
		values: [
			'Abandonment',
			'Assault and Battery',
			'Breach of Contract or Warranty',
			'Breach of Patient Confidentiality',
			'Equipment Malfunction',
			'Failure to Conform with Regulation, Statute, or Rule',
			'Failure to Ensure Patient Safety',
			'Failure to Obtain Consent or Lack of Informed Consent',
			'Failure to Protect a Third Party (Failure to Warn, etc.)',
			'Failure to Test Equipment',
			'False Imprisonment',
			'Improper Conduct',
			'Inadequate Utilization Review',
			'Negligent Credentialing',
			'Practitioner with Communicable Disease',
			'Product Liability',
			'Religious Issues',
			'Sexual Misconduct',
			'Third Party Claimant',
			'Vicarious Liability',
			'Wrongful Life/Birth',
			'Missing and/or cannot Be Determined from Available Records',
			'Allegation – Not Otherwise Classified, Specify',
		],
	},
];

export const Injuries = [{
		code: '004',
		name: 'Abrasion'
	},
	{
		code: '029',
		name: 'Abscess'
	},
	{
		code: '031',
		name: 'Adverse Reaction'
	},
	{
		code: '032',
		name: 'Aggravated/Worsened'
	},
	{
		code: '105',
		name: 'Amputation - Partial'
	},
	{
		code: '106',
		name: 'Amputation - Total'
	},
	{
		code: '003',
		name: 'Anaphylaxis/Allergic Reaction'
	},
	{
		code: '142',
		name: 'Arrest'
	},
	{
		code: '150',
		name: 'Arrhythmia'
	},
	{
		code: '107',
		name: 'Arthritis'
	},
	{
		code: '033',
		name: 'Aspiration'
	},
	{
		code: '108',
		name: 'Atrophy'
	},
	{
		code: '025',
		name: 'Benign Growth'
	},
	{
		code: '119',
		name: 'Birth Injury/Defect'
	},
	{
		code: '010',
		name: 'Burn'
	},
	{
		code: '155',
		name: 'Cardiogenic Shock'
	},
	{
		code: '034',
		name: 'Cerebral Palsy'
	},
	{
		code: '036',
		name: 'Cognitive Dysfunction'
	},
	{
		code: '120',
		name: 'Coma'
	},
	{
		code: '013',
		name: 'Compression'
	},
	{
		code: '035',
		name: 'Concussion'
	},
	{
		code: '110',
		name: 'Contracture'
	},
	{
		code: '100',
		name: 'Contusion/Bruise'
	},
	{
		code: '037',
		name: 'Cosmetic Injury'
	},
	{
		code: '140',
		name: 'Death'
	},
	{
		code: '111',
		name: 'Deformity'
	},
	{
		code: '053',
		name: 'Dehiscence'
	},
	{
		code: '001',
		name: 'Dermatitis'
	},
	{
		code: '021',
		name: 'Dislocation'
	},
	{
		code: '022',
		name: 'Displacement'
	},
	{
		code: '027',
		name: 'Dyscrasia (Blood)'
	},
	{
		code: '017',
		name: 'Edema'
	},
	{
		code: '019',
		name: 'Embolism/Thrombosis'
	},
	{
		code: '131',
		name: 'Emotional Trauma'
	},
	{
		code: '020',
		name: 'Fistula'
	},
	{
		code: '023',
		name: 'Foreign Body'
	},
	{
		code: '011',
		name: 'Fracture Open/Closed'
	},
	{
		code: '038',
		name: 'GI Dysfunction'
	},
	{
		code: '051',
		name: 'GU Dysfunction'
	},
	{
		code: '039',
		name: 'Headache'
	},
	{
		code: '014',
		name: 'Hematoma'
	},
	{
		code: '015',
		name: 'Hemorrhage'
	},
	{
		code: '016',
		name: 'Herniation'
	},
	{
		code: '121',
		name: 'Hospitalization'
	},
	{
		code: '156',
		name: 'Hypovolemia'
	},
	{
		code: '149',
		name: 'Infant/Fetal Death'
	},
	{
		code: '018',
		name: 'Infarction'
	},
	{
		code: '026',
		name: 'Infection'
	},
	{
		code: '109',
		name: 'Infection - Chronic'
	},
	{
		code: '152',
		name: 'Infection - Incision'
	},
	{
		code: '143',
		name: 'Infection - Nosocomial'
	},
	{
		code: '144',
		name: 'Infiltration (IV)'
	},
	{
		code: '002',
		name: 'Inflammation'
	},
	{
		code: '132',
		name: 'Injury To Reputation'
	},
	{
		code: '154',
		name: 'Ischemia'
	},
	{
		code: '006',
		name: 'Laceration/Tear'
	},
	{
		code: '049',
		name: 'Life Expectancy'
	},
	{
		code: '117',
		name: 'Loss - Partial (Impaired)'
	},
	{
		code: '118',
		name: 'Loss - Total'
	},
	{
		code: '130',
		name: 'Loss of Consortium/Companionship'
	},
	{
		code: '126',
		name: 'Loss of Earning Capacity'
	},
	{
		code: '125',
		name: 'Loss of Past Earnings'
	},
	{
		code: '128',
		name: 'Loss/Damage of Property'
	},
	{
		code: '024',
		name: 'Malignancy'
	},
	{
		code: '040',
		name: 'Malunion/Nonunion'
	},
	{
		code: '112',
		name: 'Metastasis'
	},
	{
		code: '134',
		name: 'Miscarriage/Abortion'
	},
	{
		code: '041',
		name: 'Mobility Dysfunction'
	},
	{
		code: '101',
		name: 'Multisystem Failure'
	},
	{
		code: '028',
		name: 'Necrosis'
	},
	{
		code: '123',
		name: 'Need For Ambulatory Care'
	},
	{
		code: '124',
		name: 'Need For Home Care'
	},
	{
		code: '141',
		name: 'Need For Surgery/Procedure'
	},
	{
		code: '113',
		name: 'Nerve Damage'
	},
	{
		code: '138',
		name: 'None'
	},
	{
		code: '146',
		name: 'Not Applicable'
	},
	{
		code: '030',
		name: 'Obstruction'
	},
	{
		code: '042',
		name: 'Organ Damage'
	},
	{
		code: '043',
		name: 'Organ Loss'
	},
	{
		code: '104',
		name: 'Overdose'
	},
	{
		code: '129',
		name: 'Pain'
	},
	{
		code: '114',
		name: 'Paralysis - Partial'
	},
	{
		code: '115',
		name: 'Paralysis - Total'
	},
	{
		code: '135',
		name: 'Pregnancy Unwanted'
	},
	{
		code: '122',
		name: 'Prolongation Of Hospitalization'
	},
	{
		code: '007',
		name: 'Puncture/Perforation'
	},
	{
		code: '139',
		name: 'Radiation Therapy Complications'
	},
	{
		code: '044',
		name: 'Rape'
	},
	{
		code: '148',
		name: 'Rupture'
	},
	{
		code: '116',
		name: 'Scarring'
	},
	{
		code: '160',
		name: 'Seizure'
	},
	{
		code: '103',
		name: 'Self Inflicted Injury'
	},
	{
		code: '045',
		name: 'Sensory Impaired'
	},
	{
		code: '151',
		name: 'Sepsis'
	},
	{
		code: '008',
		name: 'Severance'
	},
	{
		code: '050',
		name: 'Sexual Dysfunction'
	},
	{
		code: '046',
		name: 'Sterility/Infertility'
	},
	{
		code: '133',
		name: 'Stillbirth'
	},
	{
		code: '012',
		name: 'Strain/Sprain'
	},
	{
		code: '102',
		name: 'Suicide/Attempted Suicide'
	},
	{
		code: '005',
		name: 'Tear'
	},
	{
		code: '047',
		name: 'Teeth Damage'
	},
	{
		code: '009',
		name: 'Ulceration'
	},
	{
		code: '048',
		name: 'Unemployment'
	},
	{
		code: '127',
		name: 'Uninsured Medical Expenses'
	},
	{
		code: '136',
		name: 'Unknown'
	},
	{
		code: '153',
		name: 'Unnecessary Surgery'
	},
	{
		code: '147',
		name: 'Wrong Site Surgery/Procedure'
	},
	{
		code: '000',
		name: 'Not Specified'
	}
];

export const BodyParts = [{
		code: ' 088',
		name: 'Abdominal/Peritoneal Cavity'
	},
	{
		code: ' 110',
		name: 'Adrenal'
	},
	{
		code: ' 014',
		name: 'Ankle(s)'
	},
	{
		code: ' 073',
		name: 'Anus'
	},
	{
		code: ' 069',
		name: 'Appendix'
	},
	{
		code: ' 033',
		name: 'Arm (Dominant)'
	},
	{
		code: ' 034',
		name: 'Arm (Non-Dominant)'
	},
	{
		code: ' 035',
		name: 'Arms'
	},
	{
		code: ' 005',
		name: 'Back'
	},
	{
		code: ' 074',
		name: 'Bladder'
	},
	{
		code: ' 093',
		name: 'Blood'
	},
	{
		code: ' 090',
		name: 'Blood Vessel (Major)'
	},
	{
		code: ' 091',
		name: 'Blood Vessel (Minor)'
	},
	{
		code: ' 002',
		name: 'Body Below Neck'
	},
	{
		code: ' 001',
		name: 'Body Below Waist'
	},
	{
		code: ' 007',
		name: 'Body Entire'
	},
	{
		code: ' 003',
		name: 'Body Left Side'
	},
	{
		code: ' 004',
		name: 'Body Right Side'
	},
	{
		code: ' 008',
		name: 'Bone'
	},
	{
		code: ' 131',
		name: 'Bone Marrow'
	},
	{
		code: ' 054',
		name: 'Brain'
	},
	{
		code: ' 055',
		name: 'Breast'
	},
	{
		code: ' 056',
		name: 'Breasts'
	},
	{
		code: ' 022',
		name: 'Buttocks'
	},
	{
		code: ' 113',
		name: 'Cardiac'
	},
	{
		code: ' 103',
		name: 'Cartilage'
	},
	{
		code: ' 009',
		name: 'Central Nervous System'
	},
	{
		code: ' 094',
		name: 'Cerebral Spinal Fluid'
	},
	{
		code: ' 087',
		name: 'Cervix'
	},
	{
		code: ' 006',
		name: 'Chest'
	},
	{
		code: ' 112',
		name: 'Circulation'
	},
	{
		code: ' 026',
		name: 'Clavicle'
	},
	{
		code: ' 127',
		name: 'Coccyx'
	},
	{
		code: ' 071',
		name: 'Colon'
	},
	{
		code: ' 152',
		name: 'Diaphragm'
	},
	{
		code: ' 116',
		name: 'Digestive'
	},
	{
		code: ' 049',
		name: 'Ear'
	},
	{
		code: ' 052',
		name: 'Ears'
	},
	{
		code: ' 030',
		name: 'Elbow(s)'
	},
	{
		code: ' 119',
		name: 'Endocrine'
	},
	{
		code: ' 067',
		name: 'Esophagus'
	},
	{
		code: ' 050',
		name: 'Eye'
	},
	{
		code: ' 051',
		name: 'Eyes'
	},
	{
		code: ' 047',
		name: 'Face'
	},
	{
		code: ' 078',
		name: 'Fallopian Tube'
	},
	{
		code: ' 079',
		name: 'Fallopian Tubes'
	},
	{
		code: ' 125',
		name: 'Fetus'
	},
	{
		code: ' 040',
		name: 'Fingers(s)'
	},
	{
		code: ' 013',
		name: 'Foot/Feet'
	},
	{
		code: ' 031',
		name: 'Forearm (Dominant)'
	},
	{
		code: ' 032',
		name: 'Forearm (Non-Dominant)'
	},
	{
		code: ' 061',
		name: 'Gallbladder/CB Duct'
	},
	{
		code: ' 036',
		name: 'Hand (Dominant)'
	},
	{
		code: ' 037',
		name: 'Hand (Non-Dominant)'
	},
	{
		code: ' 038',
		name: 'Hands'
	},
	{
		code: ' 010',
		name: 'Head'
	},
	{
		code: ' 133',
		name: 'Hearing'
	},
	{
		code: ' 057',
		name: 'Heart'
	},
	{
		code: ' 118',
		name: 'Hematologic'
	},
	{
		code: ' 117',
		name: 'Hepatic'
	},
	{
		code: ' 020',
		name: 'Hip(s)'
	},
	{
		code: ' 111',
		name: 'Immune System'
	},
	{
		code: ' 070',
		name: 'Intestine (Small)'
	},
	{
		code: ' 044',
		name: 'Jaw'
	},
	{
		code: ' 063',
		name: 'Kidney'
	},
	{
		code: ' 064',
		name: 'Kidneys'
	},
	{
		code: ' 018',
		name: 'Knee'
	},
	{
		code: ' 019',
		name: 'Knees'
	},
	{
		code: ' 066',
		name: 'Larynx'
	},
	{
		code: ' 015',
		name: 'Leg Lower'
	},
	{
		code: ' 016',
		name: 'Leg Upper'
	},
	{
		code: ' 017',
		name: 'Legs'
	},
	{
		code: ' 102',
		name: 'Ligament'
	},
	{
		code: ' 046',
		name: 'Lip(s)'
	},
	{
		code: ' 062',
		name: 'Liver'
	},
	{
		code: ' 058',
		name: 'Lung'
	},
	{
		code: ' 059',
		name: 'Lungs'
	},
	{
		code: ' 120',
		name: 'Lymphatic'
	},
	{
		code: ' 095',
		name: 'Lymphatics'
	},
	{
		code: ' 123',
		name: 'Motor Function'
	},
	{
		code: ' 045',
		name: 'Mouth'
	},
	{
		code: ' 149',
		name: 'Muscle'
	},
	{
		code: ' 042',
		name: 'Neck'
	},
	{
		code: ' 100',
		name: 'Nerve'
	},
	{
		code: ' 048',
		name: 'Nose'
	},
	{
		code: ' 146',
		name: 'Not Applicable'
	},
	{
		code: ' 077',
		name: 'Ovaries'
	},
	{
		code: ' 076',
		name: 'Ovary'
	},
	{
		code: ' 065',
		name: 'Pancreas'
	},
	{
		code: ' 085',
		name: 'Pelvic Bone'
	},
	{
		code: ' 081',
		name: 'Penis'
	},
	{
		code: ' 096',
		name: 'Perineum'
	},
	{
		code: ' 097',
		name: 'Placenta'
	},
	{
		code: ' 129',
		name: 'Prostate'
	},
	{
		code: ' 109',
		name: 'Psychiatric Function'
	},
	{
		code: ' 072',
		name: 'Rectum'
	},
	{
		code: ' 115',
		name: 'Renal/Urinary'
	},
	{
		code: ' 114',
		name: 'Respiratory'
	},
	{
		code: ' 027',
		name: 'Ribs'
	},
	{
		code: ' 053',
		name: 'Scalp/Forehead'
	},
	{
		code: ' 082',
		name: 'Scrotum'
	},
	{
		code: ' 106',
		name: 'Sexual Function'
	},
	{
		code: ' 029',
		name: 'Shoulder(s)'
	},
	{
		code: ' 130',
		name: 'Skin'
	},
	{
		code: ' 128',
		name: 'Skull'
	},
	{
		code: ' 136',
		name: 'Smell'
	},
	{
		code: ' 140',
		name: 'Speech'
	},
	{
		code: ' 126',
		name: 'Spine'
	},
	{
		code: ' 023',
		name: 'Spine - Cervical'
	},
	{
		code: ' 025',
		name: 'Spine - Lumbar'
	},
	{
		code: ' 098',
		name: 'Spine - Sacral'
	},
	{
		code: ' 024',
		name: 'Spine - Thoracic'
	},
	{
		code: ' 060',
		name: 'Spleen'
	},
	{
		code: ' 068',
		name: 'Stomach'
	},
	{
		code: ' 101',
		name: 'Tendon'
	},
	{
		code: ' 083',
		name: 'Testicle'
	},
	{
		code: ' 084',
		name: 'Testicles'
	},
	{
		code: ' 012',
		name: 'Throat'
	},
	{
		code: ' 041',
		name: 'Thumb(s)'
	},
	{
		code: ' 150',
		name: 'Thyroid'
	},
	{
		code: ' 011',
		name: 'Toe(s)'
	},
	{
		code: ' 148',
		name: 'Tongue'
	},
	{
		code: ' 043',
		name: 'Tooth/Teeth'
	},
	{
		code: ' 105',
		name: 'Touch'
	},
	{
		code: ' 147',
		name: 'Trachea'
	},
	{
		code: ' 092',
		name: 'Umbilical Cord'
	},
	{
		code: ' 145',
		name: 'Unknown'
	},
	{
		code: ' 089',
		name: 'Ureter'
	},
	{
		code: ' 080',
		name: 'Urethra'
	},
	{
		code: ' 075',
		name: 'Uterus'
	},
	{
		code: ' 086',
		name: 'Vagina'
	},
	{
		code: ' 132',
		name: 'Vision'
	},
	{
		code: ' 151',
		name: 'Vocal Cord'
	},
	{
		code: ' 039',
		name: 'Wrist(s)'
	},
	{
		code: ' 000',
		name: 'Not Specified'
	}
];

export const Severity = [{
		code: '0',
		name: 'Legal issue only'
	},
	{
		code: '1',
		name: 'Emotional only'
	},
	{
		code: '2',
		name: 'Temporary insignificant'
	},
	{
		code: '3',
		name: 'Temporary minor'
	},
	{
		code: '4',
		name: 'Temporary major'
	},
	{
		code: '5',
		name: 'Permanent minor'
	},
	{
		code: '6',
		name: 'Permanent significant'
	},
	{
		code: '7',
		name: 'Permanent major'
	},
	{
		code: '8',
		name: 'Permanent grave'
	},
	{
		code: '9',
		name: 'Death'
	},
	{
		code: 'B',
		name: 'Infant/fetal death'
	},
	{
		code: 'N/A',
		name: 'Severity Not Specified'
	},
	{
		code: '10',
		name: 'Cannot be determined'
	}
];

export const PatientClass = [{
		code: 'IP',
		name: 'Inpatient'
	},
	{
		code: 'OP',
		name: 'Outpatient'
	},
	{
		code: 'ED',
		name: 'Emergency'
	},
	{
		code: 'LTC',
		name: 'LTC Resident'
	},
	{
		code: 'Employee',
		name: 'Employee'
	},
	{
		code: 'Visitor',
		name: 'Visitor'
	},
	{
		code: 'Other',
		name: 'Other'
	},
];
